// JsaControlMeasuresV2
export class JsaControlMeasuresV2 {
  constructor(data = {}) {
    // PPE section - ppeEye, ppeHearing, ppeRefVest, ppeHardHat are true by default
    this.ppeThermal = data.ppe_thermal || false;
    this.ppeEye = data.ppe_eye || true;
    this.ppeDermalHand = data.ppe_dermal_hand || false;
    this.ppeHearing = data.ppe_hearing || true;
    this.ppeRespirator = data.ppe_respirator || false;
    this.ppeSuppAir = data.ppe_supp_air || false;
    this.ppeApr = data.ppe_apr || false;
    this.ppeControlAprCart = data.ppe_control_apr_cart || false;
    this.ppeRefVest = data.ppe_ref_vest || true;
    this.ppeFloatation = data.ppe_floatation || false;
    this.ppeHardHat = data.ppe_hard_hat || true;
    this.ppeWorkboot = data.ppe_workboot || false;
    // Excavation section
    this.excavSloping = data.excav_sloping || false;
    this.excavShoring = data.excav_shoring || false;
    this.excavTrenchBox = data.excav_trench_box || false;
    this.excavBarricades = data.excav_barricades || false;
    this.excavCompPerson = data.excav_comp_person || false;
    this.excavBuriedUtil = data.excav_buried_util || false;
    this.excavInspection = data.excav_inspection || false;
    this.excavExcZone = data.excav_exc_zone || false;
    this.excavUndermining = data.excav_undermining || false;
    this.excavSpoilsMin = data.excav_spoils_min || false;
    this.excavVehWheelChock = data.excav_veh_wheel_chock || false;
    this.excavAdequateAccess = data.excav_adequate_access || false;
    this.excavHoleCover = data.excav_hole_cover || false;
    this.excavWarningSigns = data.excav_warning_signs || false;
    this.excavMatEdgeStorage = data.excav_mat_edge_storage || false;
    // Electrical section
    this.elecLoto = data.elec_loto || false;
    this.elecGrounded = data.elec_grounded || false;
    this.elecPanelCover = data.elec_panel_cover || false;
    this.elecGfciExtCord = data.elec_gfci_ext_cord || false;
    this.elecPtCordInsp = data.elec_pt_cord_insp || false;
    this.elecOverheadLine = data.elec_overhead_line || false;
    this.elecWarningSigns = data.elec_warning_signs || false;
    this.elecSpotter = data.elec_spotter || false;
    this.elecHandHydroExcav = data.elec_hand_hydro_excav || false;
    // Fall Protection section
    this.fallHarnessLanyard = data.fall_harness_lanyard || false;
    this.fallAdequateAnchor = data.fall_adequate_anchor || false;
    this.fallGuardrail = data.fall_guardrail || false;
    this.fallCoveredOpenings = data.fall_covered_openings || false;
    this.fallFixedBarricades = data.fall_fixed_barricades || false;
    this.fallWarningSystem = data.fall_warning_system || false;
    // Protection of Public section
    this.popFencing = data.pop_fencing || false;
    this.popCoveredWalkway = data.pop_covered_walkway || false;
    this.popBarriers = data.pop_barriers || false;
    this.popPedWalkway = data.pop_ped_walkway || false;
    this.popWarningSigns = data.pop_warning_signs || false;
    this.popSecurity = data.pop_security || false;
    this.popFlagger = data.pop_flagger || false;
    // Equipment section - equipSeatBelts, equipNoCellphone are true by default
    this.equipSuitable = data.equip_suitable || false;
    this.equipInspLift = data.equip_insp_lift || false;
    this.equipWarningDev = data.equip_warning_dev || false;
    this.equipSeatBelts = data.equip_seat_belts || true;
    this.equipExcZone = data.equip_exc_zone || false;
    this.equipPedRoute = data.equip_ped_route || false;
    this.equipFencing = data.equip_fencing || false;
    this.equipGuzzlerSafety = data.equip_guzzler_safety || false;
    this.equipSafeWorkLoad = data.equip_safe_work_load || false;
    this.equipLockAttach = data.equip_lock_attach || false;
    this.equipFlagger = data.equip_flagger || false;
    this.equipRigger = data.equip_rigger || false;
    this.equipSpeedSign = data.equip_speed_sign || false;
    this.equipNoPass = data.equip_no_pass || false;
    this.equipNoCellphone = data.equip_no_cellphone || true;
    // Confined Space section
    this.csSurveyed = data.cs_surveyed || false;
    this.csAirMon = data.cs_air_mon || false;
    this.csReSys = data.cs_re_sys || false;
    this.csTrainedPerson = data.cs_trained_person || false;
    this.csCompPerson = data.cs_comp_person || false;
    this.csRiskAssess = data.cs_risk_assess || false;
    this.csRescue = data.cs_rescue || false;
    this.csComms = data.cs_comms || false;
    // Medical section
    this.medFirstAid = data.med_first_aid || false;
    this.medEyeWash = data.med_eye_wash || false;
    this.medCpr = data.med_cpr || false;
    this.medHopsitalRoute = data.med_hopsital_route || false;
    // Heat/Cold Stress section
    this.hcWorkRest = data.hc_work_rest || false;
    this.hcRestArea = data.hc_rest_area || false;
    this.hcLiqAvail = data.hc_liq_avail || false;
    this.hcMonitoring = data.hc_monitoring || false;
    this.hcTraining = data.hc_training || false;
    // Vehicle Traffic section
    this.vtTrafControl = data.vt_traf_control || false;
    this.vtBarricades = data.vt_barricades || false;
    this.vtFlags = data.vt_flags || false;
    this.vtSigns = data.vt_signs || false;
    // Permits section
    this.permHotWork = data.perm_hot_work || false;
    this.permConfinedSpace = data.perm_confined_space || false;
    this.permExcavation = data.perm_excavation || false;
    this.permLoto = data.perm_loto || false;
    this.permDemo = data.perm_demo || false;
    this.permEnergized = data.perm_energized || false;
    // Welding/Cutting section
    this.wcCylinderSec = data.wc_cylinder_sec || false;
    this.wcCylinderSep = data.wc_cylinder_sep || false;
    this.wcFbArrestor = data.wc_fb_arrestor || false;
    this.wcNoCylCse = data.wc_no_cyl_cse || false;
    this.wcFlamRetCloth = data.wc_flam_ret_cloth || false;
    this.wcAppGoggles = data.wc_app_goggles || false;
    // Inspections section
    this.inspLadAerial = data.insp_lad_aerial || false;
    this.inspLanHarness = data.insp_lan_harness || false;
    this.inspScaffold = data.insp_scaffold || false;
    this.inspHeavyEquip = data.insp_heavy_equip || false;
    this.inspCraneRig = data.insp_crane_rig || false;
    // Training section
    this.trainHazwoper = data.train_hazwoper || false;
    this.trainConstruction = data.train_construction || false;
    this.trainCompPerson = data.train_comp_person || false;
    this.trainTaskSpecific = data.train_task_specific || false;
    this.trainHazcom = data.train_hazcom || false;
    // Fire Protection section
    this.fireExtinguisher = data.fire_extinguisher || false;
    this.fireWatch = data.fire_watch || false;
    this.fireNonsparkTools = data.fire_nonspark_tools || false;
    this.fireGrounding = data.fire_grounding || false;
    this.fireIntrinSafeEquip = data.fire_intrin_safe_equip || false;
    // Hand Tools section
    this.htSuitability = data.ht_suitability || false;
    this.htVoltageKnown = data.ht_voltage_known || false;
    this.htInspectCord = data.ht_inspect_cord || false;
    this.htFuncGuard = data.ht_func_guard || false;
    this.htGeneratorOut = data.ht_generator_out || false;
    this.htToolsRep = data.ht_tools_rep || false;
  }

  // Update the attribute value of the class
  updateAttribute(attribute, value) {
    this[attribute] = value;
  }

  // Update if the view section is expanded or not
  updateViewSection(section, value) {
    this[section] = value;
  }

  // Helper function to convert camelCase to snake_case
  setSnakeCaseField(field) {
    return field.replace(/([A-Z])/g, "_$1").toLowerCase();
  }

  // To json for sending to the database
  toJson() {
    return {
      ppe_thermal: this.ppeThermal,
      ppe_eye: this.ppeEye,
      ppe_dermal_hand: this.ppeDermalHand,
      ppe_hearing: this.ppeHearing,
      ppe_respirator: this.ppeRespirator,
      ppe_supp_air: this.ppeSuppAir,
      ppe_apr: this.ppeApr,
      ppe_control_apr_cart: this.ppeControlAprCart,
      ppe_ref_vest: this.ppeRefVest,
      ppe_floatation: this.ppeFloatation,
      ppe_hard_hat: this.ppeHardHat,
      ppe_workboot: this.ppeWorkboot,
      excav_sloping: this.excavSloping,
      excav_shoring: this.excavShoring,
      excav_trench_box: this.excavTrenchBox,
      excav_barricades: this.excavBarricades,
      excav_comp_person: this.excavCompPerson,
      excav_buried_util: this.excavBuriedUtil,
      excav_inspection: this.excavInspection,
      excav_exc_zone: this.excavExcZone,
      excav_undermining: this.excavUndermining,
      excav_spoils_min: this.excavSpoilsMin,
      excav_veh_wheel_chock: this.excavVehWheelChock,
      excav_adequate_access: this.excavAdequateAccess,
      excav_hole_cover: this.excavHoleCover,
      excav_warning_signs: this.excavWarningSigns,
      excav_mat_edge_storage: this.excavMatEdgeStorage,
      elec_loto: this.elecLoto,
      elec_grounded: this.elecGrounded,
      elec_panel_cover: this.elecPanelCover,
      elec_gfci_ext_cord: this.elecGfciExtCord,
      elec_pt_cord_insp: this.elecPtCordInsp,
      elec_overhead_line: this.elecOverheadLine,
      elec_warning_signs: this.elecWarningSigns,
      elec_spotter: this.elecSpotter,
      elec_hand_hydro_excav: this.elecHandHydroExcav,
      fall_harness_lanyard: this.fallHarnessLanyard,
      fall_adequate_anchor: this.fallAdequateAnchor,
      fall_guardrail: this.fallGuardrail,
      fall_covered_openings: this.fallCoveredOpenings,
      fall_fixed_barricades: this.fallFixedBarricades,
      fall_warning_system: this.fallWarningSystem,
      pop_fencing: this.popFencing,
      pop_covered_walkway: this.popCoveredWalkway,
      pop_barriers: this.popBarriers,
      pop_ped_walkway: this.popPedWalkway,
      pop_warning_signs: this.popWarningSigns,
      pop_security: this.popSecurity,
      pop_flagger: this.popFlagger,
      equip_suitable: this.equipSuitable,
      equip_insp_lift: this.equipInspLift,
      equip_warning_dev: this.equipWarningDev,
      equip_seat_belts: this.equipSeatBelts,
      equip_exc_zone: this.equipExcZone,
      equip_ped_route: this.equipPedRoute,
      equip_fencing: this.equipFencing,
      equip_guzzler_safety: this.equipGuzzlerSafety,
      equip_safe_work_load: this.equipSafeWorkLoad,
      equip_lock_attach: this.equipLockAttach,
      equip_flagger: this.equipFlagger,
      equip_rigger: this.equipRigger,
      equip_speed_sign: this.equipSpeedSign,
      equip_no_pass: this.equipNoPass,
      equip_no_cellphone: this.equipNoCellphone,
      cs_surveyed: this.csSurveyed,
      cs_air_mon: this.csAirMon,
      cs_re_sys: this.csReSys,
      cs_trained_person: this.csTrainedPerson,
      cs_comp_person: this.csCompPerson,
      cs_risk_assess: this.csRiskAssess,
      cs_rescue: this.csRescue,
      cs_comms: this.csComms,
      med_first_aid: this.medFirstAid,
      med_eye_wash: this.medEyeWash,
      med_cpr: this.medCpr,
      med_hopsital_route: this.medHopsitalRoute,
      hc_work_rest: this.hcWorkRest,
      hc_rest_area: this.hcRestArea,
      hc_liq_avail: this.hcLiqAvail,
      hc_monitoring: this.hcMonitoring,
      hc_training: this.hcTraining,
      vt_traf_control: this.vtTrafControl,
      vt_barricades: this.vtBarricades,
      vt_flags: this.vtFlags,
      vt_signs: this.vtSigns,
      perm_hot_work: this.permHotWork,
      perm_confined_space: this.permConfinedSpace,
      perm_excavation: this.permExcavation,
      perm_loto: this.permLoto,
      perm_demo: this.permDemo,
      perm_energized: this.permEnergized,
      wc_cylinder_sec: this.wcCylinderSec,
      wc_cylinder_sep: this.wcCylinderSep,
      wc_fb_arrestor: this.wcFbArrestor,
      wc_no_cyl_cse: this.wcNoCylCse,
      wc_flam_ret_cloth: this.wcFlamRetCloth,
      wc_app_goggles: this.wcAppGoggles,
      insp_lad_aerial: this.inspLadAerial,
      insp_lan_harness: this.inspLanHarness,
      insp_scaffold: this.inspScaffold,
      insp_heavy_equip: this.inspHeavyEquip,
      insp_crane_rig: this.inspCraneRig,
      train_hazwoper: this.trainHazwoper,
      train_construction: this.trainConstruction,
      train_comp_person: this.trainCompPerson,
      train_task_specific: this.trainTaskSpecific,
      train_hazcom: this.trainHazcom,
      fire_extinguisher: this.fireExtinguisher,
      fire_watch: this.fireWatch,
      fire_nonspark_tools: this.fireNonsparkTools,
      fire_grounding: this.fireGrounding,
      fire_intrin_safe_equip: this.fireIntrinSafeEquip,
      ht_suitability: this.htSuitability,
      ht_voltage_known: this.htVoltageKnown,
      ht_inspect_cord: this.htInspectCord,
      ht_func_guard: this.htFuncGuard,
      ht_generator_out: this.htGeneratorOut,
      ht_tools_rep: this.htToolsRep,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const patch = {
      patch_type: "jsa_control_measures_v2",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const snakeCaseField = this.setSnakeCaseField(key);
      patch[snakeCaseField] = value;
    }

    return patch;
  }
}
